import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class MobileScaleService {
  private document = inject<Document>(DOCUMENT);


  THRESHOLD_SIZE = 768;
  BG_SM_WIDTH = 240;     // 2 * 2 * 2 * 2 * 3 * 5
  MON_SPRITE_WIDTH = 96; // 2 * 2 * 2 * 2 * 3 * 2
  MINI_SPRITE_WIDTH = 32; // 2 * 2 * 2 * 2 * 2
  COMMON_DENOM = 12;
  COMMON_FACTOR = 20; // 240 / COMMON_DENOM
  PADDING = 2;

  private renderer: Renderer2;
  isMobile: boolean;
  isZoomed: boolean = false;
  innerWidthAccountingForPadding: number;
  bgWidth: number;
  monSpriteWidth: number;
  miniSpriteWidth: number;

  constructor() {
    const rendererFactory = inject(RendererFactory2);

    this.renderer = rendererFactory.createRenderer(null, null);
    this.isMobile = window.innerWidth <= this.THRESHOLD_SIZE;
    this.innerWidthAccountingForPadding = window.innerWidth - this.PADDING;

    // Calculate the largest common scaling I can apply to both 96, 180, and 240 such that the width is below the max innerwidth and both numbers are whole numbers
    const scaleFactor = Math.floor(this.innerWidthAccountingForPadding / this.COMMON_FACTOR);

    // These are guaranteed to be whole numbers
    this.bgWidth = this.BG_SM_WIDTH * scaleFactor / this.COMMON_DENOM;
    this.monSpriteWidth = this.MON_SPRITE_WIDTH * scaleFactor / this.COMMON_DENOM;

    let miniSpriteWidth = Math.round(this.MINI_SPRITE_WIDTH * scaleFactor / this.COMMON_DENOM);
    if (miniSpriteWidth % 2 !== 0) {
      miniSpriteWidth += 1;
    }
    this.miniSpriteWidth = miniSpriteWidth;

    if (this.isMobile) {
      this.document.documentElement.style.setProperty('--mobile-bg-width', this.bgWidth + 'px');
    }

    this.detectTextScaling();
  }

  private detectTextScaling(): void {
    const testElement = this.renderer.createElement('div');
    Object.assign(testElement.style, {
      position: 'fixed',
      visibility: 'hidden',
      top: '0',
      left: '0',
      fontSize: '16px',
      lineHeight: '1',
      maxWidth: '100vw',
      wordBreak: 'break-all'
    });
    this.renderer.setProperty(testElement, 'textContent', 'MMMMMMMMMMMMMMMMMMMMMMM'); // Minimum number of characters needed to trigger line break

    this.renderer.appendChild(this.document.body, testElement);

    // Measure the height - if it's greater than one line, text has wrapped due to zoom
    const height = testElement.offsetHeight;
    const lineHeight = parseFloat(window.getComputedStyle(testElement).lineHeight);

    this.isZoomed = height > lineHeight;

    this.renderer.removeChild(this.document.body, testElement);
  }
}